(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
     window.addEventListener('DOMContentLoaded', () => { const footerText = document.querySelector('.footer-text'); const setFooterTextCssVariable = () => { document.documentElement.style.setProperty('--footer-text-width', footerText.clientWidth + "px"); }; setFooterTextCssVariable(); window.addEventListener('resize', setFooterTextCssVariable); window.addEventListener('load', setFooterTextCssVariable); }) 
  } catch(e) { console.error(e); }
})();
})();
